//Testimonials Slider
$('.glide').each(function () {
    const slider = new Glide(".glide", {
        type: "carousel",
        perView: 2,
        keyboard: true,
        breakpoints: {
            992: {
                perView: 1
            }
        }
    }).mount();
});
